/**
 * Wrapper around clearTimeout that strongly types returned value.
 */
export function clearTimeout(timeoutId: number | NodeJS.Timeout): void {
    // tslint:disable-next-line no-typeof-undefined
    if (typeof timeoutId !== "number") {
        global.clearTimeout(timeoutId);
    } else {
        window.clearTimeout(timeoutId);
    }
}
